var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "modal",
        {
          staticClass: "modal-measure",
          attrs: {
            show: _vm.showModal,
            title: _vm.title,
            needFooter: false,
            centered: true,
            contentCentered: true,
            hasBackdrop: false,
            draggable: true,
            size: "small",
            saveButton: {
              visible: false,
            },
            cancelButton: {
              visible: false,
            },
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            { staticClass: "panel-control d-flex flex-column flex-fill" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "panel-control-content d-flex flex-column flex-fill",
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn-toolbar w-100 justify-content-center",
                          attrs: { role: "toolbar", "aria-label": "" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group btn-block",
                              attrs: { role: "group", "aria-label": "Actions" },
                            },
                            _vm._l(_vm.activeActions, function (action, key) {
                              return _c(
                                "button",
                                {
                                  key: key,
                                  staticClass:
                                    "btn btn-secondary-main min-w-auto mx-0",
                                  class: { active: _vm.actionType == key },
                                  attrs: {
                                    title: action.title,
                                    type: "button",
                                    "data-toggle": "tooltip-city",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.applyAction(key, $event)
                                    },
                                  },
                                },
                                [_c("i", { class: action.icon })]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }